import React, { useEffect, useState } from "react";
import BreadCrumb from "../components/BreadCrumb";
import Meta from "../components/Meta";
import Container from "../components/Container";
import { useDispatch, useSelector } from "react-redux";
import { addToWishlist } from "../features/products/productSlilce";
import { getuserProductWishlist } from "../features/user/userSlice";
import { FaHeart, FaShoppingCart } from "react-icons/fa";

const Wishlist = () => {
  const dispatch = useDispatch();
  const [notification, setNotification] = useState(null);
  const [sortOption, setSortOption] = useState("default");

  // Fetch wishlist on component mount
  useEffect(() => {
    dispatch(getuserProductWishlist());
  }, [dispatch]);

  const wishlistState = useSelector((state) => state.auth.wishlist);

  // Handle removing item from wishlist
  const removeFromWishlist = (id) => {
    dispatch(addToWishlist(id));
    setNotification("Item removed from wishlist!");
    setTimeout(() => {
      dispatch(getuserProductWishlist());
      setNotification(null);
    }, 2000);
  };

  // Mock add to cart (replace with actual action)
  const addToCart = (id) => {
    setNotification("Item added to cart!");
    setTimeout(() => setNotification(null), 2000);
  };

  // Mock sort function (replace with actual sorting logic)
  const sortedWishlist = [...(wishlistState || [])].sort((a, b) => {
    if (sortOption === "price-low") return a.productId.price - b.productId.price;
    if (sortOption === "price-high") return b.productId.price - a.productId.price;
    return 0; // Default: no sorting
  });

  return (
    <>
      <Meta title="Wishlist" />
      {/* <BreadCrumb title="Wishlist" /> */}
      <Container class1="wishlist-wrapper py-10 bg-gray-50 min-h-screen">
        <style>
          {`
            @keyframes slideUp {
              0% { transform: translateY(20px); opacity: 0; }
              100% { transform: translateY(0); opacity: 1; }
            }
            @keyframes fadeIn {
              0% { opacity: 0; }
              100% { opacity: 1; }
            }
            .wishlist-card {
              animation: slideUp 0.5s ease-out forwards;
              animation-delay: calc(var(--index) * 0.1s);
            }
            .image-loading {
              background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
              background-size: 200% 100%;
              animation: shimmer 1.5s infinite;
            }
            @keyframes shimmer {
              0% { background-position: 200% 0; }
              100% { background-position: -200% 0; }
            }
            .notification {
              animation: fadeIn 0.3s ease-out;
            }
            .wishlist-icon:hover, .cart-icon:hover {
              transform: scale(1.2);
            }
            .wishlist-card:hover {
              transform: scale(1.05);
            }
          `}
        </style>
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          {/* Notification Toast */}
          {notification && (
            <div className="notification fixed top-4 right-4 bg-[#36C940] text-white px-4 py-2 rounded-lg shadow-lg z-50">
              {notification}
            </div>
          )}

          {/* Filter Bar */}
          <div className="flex justify-between items-center mb-6 sticky top-0 bg-gray-50 py-4 z-10">
            <h2 className="text-2xl sm:text-3xl font-bold text-gray-800">Your Wishlist</h2>
            <div className="flex items-center gap-2">
              <label className="text-sm text-gray-600">Sort by:</label>
              <select
                value={sortOption}
                onChange={(e) => setSortOption(e.target.value)}
                className="border border-gray-300 rounded-md px-3 py-1 text-sm focus:outline-none focus:ring-2 focus:ring-[#36C940]"
              >
                <option value="default">Default</option>
                <option value="price-low">Price: Low to High</option>
                <option value="price-high">Price: High to Low</option>
              </select>
            </div>
          </div>

          {sortedWishlist?.length === 0 ? (
            <div className="text-center py-20 flex flex-col items-center">
              {/* <img
                src="https://via.placeholder.com/150?text=No+Items"
                alt="Empty Wishlist"
                className="w-32 h-32 mb-6"
              /> */}
              <h2 className="text-3xl sm:text-4xl font-bold text-gray-800 mb-2">Your Wishlist is Empty</h2>
              <p className="text-gray-600 text-sm sm:text-base max-w-md">
                Browse our exclusive collection and save your favorite products for later!
              </p>
              <a
                href="/shop"
                className="mt-6 bg-[#36C940] text-white px-8 py-3 rounded-full hover:bg-[#2ea336] transition-colors duration-300 text-sm sm:text-base"
              >
                Shop Now
              </a>
            </div>
          ) : (
            <div className="grid grid-cols-4 gap-4 sm:gap-6 justify-items-center">
              {sortedWishlist?.map((item, index) => (
                <div
                  key={index}
                  className="wishlist-card"
                  style={{ "--index": index }}
                >
                  <div
                    className="text-center bg-white rounded-lg shadow-md hover:shadow-lg transition-all duration-300 border border-gray-100"
                    style={{
                      width: "clamp(240px, 60vw, 280px)",
                      maxWidth: "300px",
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                    }}
                  >
                    {/* Image Container */}
                    <div
                      className="product-img-container relative bg-gray-200 rounded-lg cursor-pointer"
                      style={{
                        width: "clamp(240px, 60vw, 280px)",
                        maxWidth: "300px",
                        height: "clamp(336px, 84vw, 392px)",
                        maxHeight: "420px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        aspectRatio: "4 / 5.6",
                      }}
                      onClick={() => window.location.href = `/product/${item.productId._id}`}
                    >
                      <img
                        src={
                          item?.productId?.images?.[0] ||
                          "https://via.placeholder.com/300x420?text=Placeholder"
                        }
                        alt={item?.productId?.name || "Product"}
                        className="image-loading w-full h-full object-contain min-w-full min-h-full border-2 border-transparent"
                        loading="lazy"
                        onLoad={(e) => e.target.classList.remove("image-loading")}
                        onError={(e) =>
                          (e.target.src = "https://via.placeholder.com/300x420?text=Placeholder")
                        }
                      />
                      {/* Icon Container */}
                      <div
                        className="icon-container absolute top-2 right-2 flex gap-2 z-10"
                      >
                        <FaHeart
                          className="wishlist-icon text-[#ff4d4f] cursor-pointer transition-transform duration-200"
                          style={{ fontSize: "clamp(18px, 5vw, 20px)" }}
                          onClick={(e) => {
                            e.stopPropagation();
                            removeFromWishlist(item?.productId?._id);
                          }}
                        />
                        <FaShoppingCart
                          className="cart-icon text-gray-600 cursor-pointer transition-transform duration-200"
                          style={{ fontSize: "clamp(18px, 5vw, 20px)" }}
                          onClick={(e) => {
                            e.stopPropagation();
                            addToCart(item?.productId?._id);
                          }}
                        />
                      </div>
                    </div>

                    {/* Product Details */}
                    <div className="w-full px-3 py-3 flex flex-col gap-1">
                      <div
                        className="text-sm font-medium text-[#555] truncate"
                        style={{ fontSize: "clamp(14px, 3.8vw, 15px)" }}
                      >
                        {item?.productId?.name || "Google Pixel 7"}
                      </div>
                      <div
                        className="text-xs text-gray-500 line-clamp-2"
                        style={{ fontSize: "clamp(11px, 3vw, 12px)" }}
                      >
                        {item?.productId?.description || "Latest Google smartphone with Tensor G2 chip"}
                      </div>
                      <div className="flex items-center gap-2 mt-2 flex-wrap justify-center">
                        <span
                          className="text-base font-bold"
                          style={{ fontSize: "clamp(16px, 4.2vw, 17px)" }}
                        >
                          ₹{item?.productId?.price?.toFixed(2) || "699.99"}
                        </span>
                        {item?.productId?.discount && (
                          <>
                            <span
                              className="text-sm text-gray-500 line-through"
                              style={{ fontSize: "clamp(14px, 3.8vw, 15px)" }}
                            >
                              ₹{(item.productId.price + item.productId.discount).toFixed(2)}
                            </span>
                            <span
                              className="text-sm text-[#36C940] font-medium"
                              style={{ fontSize: "clamp(14px, 3.8vw, 15px)" }}
                            >
                              ({Math.round((item.productId.discount / (item.productId.price + item.productId.discount)) * 100)}% OFF)
                            </span>
                          </>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </Container>
    </>
  );
};

export default Wishlist;